import { Component } from "@angular/core";
import { Router } from '@angular/router';

@Component({
    templateUrl: "./layout.component.html",
    styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {
    constructor(
        private router: Router
    ){}
    
    onActivate(event) {
        window.scrollTo(0, 0);
    }

    ngOnInit() {
        $(document).ready(function () {
            $('html, body').scrollTop(0);

            $(window).on('load', function () {
                setTimeout(function () {
                    $('html, body').scrollTop(0);
                }, 0);
            });
        });
    }
}
